module.exports = __webpack_public_path__ + "img/utilize@0.75x.fefe55b2.jpg";